module.exports = "/_next/static/videos/video-one-6c3610813da38a970efbeb224dc4f6ba.mp4";